import apiClient from '../apiClient';
import { GET_SCHEDULE_TOUR_TRANSACTION_URL } from '../apiUrl';

const getScheduleTourTransactionApi = Id => {
  return apiClient.get(GET_SCHEDULE_TOUR_TRANSACTION_URL(Id));
};

export default getScheduleTourTransactionApi;
